module.exports = __webpack_public_path__ + "img/f6-01.0613b840.png";